import { 
  LOAD_ENUM_GROUP_DATA_IN_PROGRESS,
  LOAD_ENUM_GROUP_DATA_SUCCESS,
  LOAD_ENUM_GROUP_DATA_FAILURE,
  OPEN_ENUMS_GROUP_DIALOG,
  CLOSE_ENUMS_GROUP_DIALOG,
  LOAD_ENUM_GROUP_SINGLE_DATA,
  ENUM_GROUP_OPERATION_COMPLETED
} from "./actions";

const initialState = { isLoading: false, enumGroupArrayData: [], enumGroupSingleData:[] };

export const enumGroupData = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    
    case LOAD_ENUM_GROUP_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        enumGroupArrayData: data,
      };
    }
    case LOAD_ENUM_GROUP_DATA_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_ENUM_GROUP_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
      case ENUM_GROUP_OPERATION_COMPLETED:
        return {
            ...state,
            isLoading: false,
        }; 
      case OPEN_ENUMS_GROUP_DIALOG:
        return {
          ...state,
          isEnumsGroupDialogOpen: true,
        }; 

      case CLOSE_ENUMS_GROUP_DIALOG:
        return {
          ...state,
          isEnumsGroupDialogOpen: false,
        }; 
      case LOAD_ENUM_GROUP_SINGLE_DATA:{
        const { data } = payload;
        return {
            ...state,
            isLoading: false,
            enumGroupSingleData : data,
        }
      }
      default:
        return state;
  }
};
